"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelayPayload = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
const Json = __importStar(require("../../../../../json"));
exports.NAMESPACE = 'Culligan.Api.V1.PubSub.PelicanBridge.Schema';
const message = effect_1.Schema.propertySignature(Json.Record).annotations({
    description: 'Command for the device, forwarded as it is to its instantMessage method. Its content is defined by the Pelican firmware. Must be an object, an empty one is let through.',
});
const idDescription = 'Id of the Pelican device. It must start with PLCN, in any letter case, which is checked only on the id that is used: deviceId when it is not empty, serialNumber otherwise.';
exports.RelayPayload = effect_1.Schema.Union(effect_1.Schema.Struct({
    deviceId: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({ description: idDescription }),
    serialNumber: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Used only when deviceId is empty or missing',
    }),
    message,
}), effect_1.Schema.Struct({
    serialNumber: effect_1.Schema.propertySignature(effect_1.Schema.NonEmptyString).annotations({
        description: idDescription,
    }),
    deviceId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Wins over serialNumber when it is not empty',
    }),
    message,
})).annotations({
    identifier: `${exports.NAMESPACE}.RelayPayload`,
    description: 'A command from the Pelican API for one Pelican device. At least one of deviceId and serialNumber is required.',
});
//# sourceMappingURL=schema.js.map